export const readOnlyKey = Symbol('readOnly');
